import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router';
import Logo from '@/components/Logo';

const SignIn: React.FC = () => {
  const [domainName, setDomainName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleProceed = () => {
    if (!domainName.trim()) {
      return;
    }

    setIsLoading(true);

    // Use a more efficient approach by opening in a new tab
    // This won't block the UI thread and is faster
    window.open(`https://${domainName}.simulationslabs.com/managerarea/login`, '_blank');

    // Reset loading state after a short delay
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  };

  return (
    <div className="flex h-screen flex-col items-center justify-center">
      <div className="mb-8 flex flex-col items-center justify-center space-y-5">
        <Logo />
        <div className="text-center text-sm">
          <span className="text-gray-400">New to Simulations Labs? </span>
          <Link
            to="https://app.simulationslabs.com/register/tenant"
            className="text-primary font-semibold hover:underline"
          >
            Sign up for free
          </Link>
        </div>
      </div>
      <div className="w-full max-w-md rounded-lg bg-white p-8 shadow-md">
        <div className="mb-6">
          <h2 className="mb-2 text-2xl font-bold text-gray-800">Welcome Back</h2>
          <p className="text-gray-600">Please enter your domain name to get started</p>
        </div>

        <div className="mb-6">
          <label htmlFor="domainName" className="mb-1 block text-sm font-medium text-gray-700">
            Domain Name
          </label>
          <div className="flex">
            <input
              type="text"
              id="domainName"
              className="focus:border-primary flex-grow rounded-l-md border border-gray-300 px-3 py-2 focus:ring-0 focus:outline-none"
              value={domainName}
              onChange={(e) => setDomainName(e.target.value)}
            />
            <div className="text-primary rounded-r-md border border-l-0 border-gray-300 bg-gray-100 px-3 py-2">
              .simulationslabs.com
            </div>
          </div>
        </div>

        <div className="mb-6 text-right">
          <Link to="https://app.simulationslabs.com/tenants/forget-domains" className="text-primary text-sm hover:underline">
            Forgot your domain name?
          </Link>
        </div>

        <button
          className={`bg-primary mb-6 w-full cursor-pointer rounded-md px-4 py-2 text-white transition-colors duration-300 hover:bg-blue-600 ${isLoading ? 'opacity-70' : ''}`}
          onClick={handleProceed}
          disabled={isLoading}
        >
          {isLoading ? 'LOADING...' : 'PROCEED'}
        </button>
      </div>
    </div>
  );
};

export default SignIn;
